<script setup lang="ts">
import { ref } from 'vue'

withDefaults(defineProps<{ variant?: 'primary' | 'secondary' | 'quiet' | 'danger', size?: 'default' | 'page', shape?: 'default' | 'pill', type?: 'button' | 'submit' | 'reset', disabled?: boolean, loading?: boolean }>(), { variant: 'secondary', size: 'default', shape: 'default', type: 'button' })
const element = ref<HTMLButtonElement>()
defineExpose({ focus: (options?: FocusOptions) => element.value?.focus(options) })
</script>

<template>
  <button ref="element" :type="type" class="st-button" :class="[`st-button--${variant}`, `st-button--${size}`, { 'st-button--pill': shape === 'pill' }]" :disabled="disabled || loading" :aria-busy="loading || undefined">
    <span v-if="loading" class="st-spinner" aria-hidden="true" /><slot />
  </button>
</template>
